module.exports = __webpack_public_path__ + "img/tile-keyframes_en.bfb8f34.jpg";